import { AbstractStore } from "~/extensions/utils/AbstractStore";
import { reactive } from "vue";
import { Pagination } from "~/extensions/api";
import { NyukyoshaFindConditionValidator } from "~/pages/admin/Nyukyosha/Models/NyukyoshaFindConditionValidator";
import { NyukyoshaFindConditionViewModel } from "~/pages/admin/Nyukyosha/Models/NyukyoshaFindConditionViewModel";
import { NyukyoshaListViewModel } from "~/pages/admin/Nyukyosha/Models/NyukyoshaListViewModel";
import Enumerable from "linq";
import { adminApi } from "~/api/admin/Api";
class Store extends AbstractStore {
    get keyName() {
        return "buknCd, roomNo";
    }
    init() {
        this.condition = new NyukyoshaFindConditionViewModel();
        this.storedCondition = new NyukyoshaFindConditionViewModel();
        this.conditionValid = new NyukyoshaFindConditionValidator(this.condition);
        this.defaultPagination = new Pagination(this.keyName, [false, false]);
        this.resetPagination();
    }
    async load() {
        let result = await adminApi.nyukyosha.find(this.condition, this.pagination);
        this.results = Enumerable.from(result.records).select(x => new NyukyoshaListViewModel(x)).toArray();
        this.pagination.rowsNumber = result.total;
        this.foundDate = result.executedDate;
    }
    clear() {
        super.clear();
    }
}
export let store = reactive(new Store());
